import React, { useRef, useEffect } from "react";
import { SearchBox } from "@quintype/components";
import { string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Icon from "../../icons";
import { staticTexts } from "../../utils/Translate";

import "./navbarSearch.m.css";

const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1" styleName="search-label" className="search-label">
    {children}
  </label>,
  <button type="submit" styleName="search__form-submit" className="search__form-submit" key="2">
    <Icon type="search" className="search-icon" />
  </button>
];

const NavbarSearch = ({ device = "desktop", publisherAttributes }) => {
  const textInput = useRef();
  const searchForm = useRef();

  useEffect(() => {
    const inputElement = document.getElementsByTagName("input")[0];
    inputElement.blur();
  }, []);

  return (
    <div styleName={`search ${device}`} className="search">
      <SearchBox
        styleName="search-box"
        inputId="searchForm"
        inputClassName={`search__form-input ${publisherAttributes.lang}-search__form-input`}
        template={DrawForm}
        inputRef={textInput}
        formRef={searchForm}
        placeholder={staticTexts(publisherAttributes.lang).searchBoxText}
        className="search-box"
      />
    </div>
  );
};

NavbarSearch.propTypes = {
  device: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(NavbarSearch);
